/** Previous route in the entrepreneur journey (PRD §5). */
export const JOURNEY_ROUTE_BACK: Record<string, string> = {
  '/map': '/',
  '/questionnaire': '/map',
  '/assessment': '/questionnaire',
  '/planning-info': '/questionnaire',
};

export function getJourneyBackTo(pathname: string): string | null {
  return JOURNEY_ROUTE_BACK[pathname] ?? null;
}
